import { useEffect, useState } from 'react';

/**
 * Segura um valor até ele parar de mudar.
 *
 * Usado no campo de duração: digitar "45" passa por "4" antes, e sem isto a
 * agenda seria recalculada para um atendimento de 4 minutos no caminho.
 */
export function useDebouncedValue<T>(value: T, delayMs = 350): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
